/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './diag-lab-inventory-bill.reducer';

export const DiagLabInventoryBillDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const diagLabInventoryBillEntity = useAppSelector(state => state.diagLabInventoryBill.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="diagLabInventoryBillDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.diagLabInventoryBill.detail.title">DiagLabInventoryBill</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryBill.id">Id</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryBillEntity.id}</dd>
          <dt>
            <span id="billNumber">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryBill.billNumber">Bill Number</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryBillEntity.billNumber}</dd>
          <dt>
            <span id="billDate">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryBill.billDate">Bill Date</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryBillEntity.billDate}</dd>
          <dt>
            <span id="totalCost">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryBill.totalCost">Total Cost</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryBillEntity.totalCost}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryBill.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryBillEntity.discount}</dd>
          <dt>
            <span id="cgst">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryBill.cgst">Cgst</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryBillEntity.cgst}</dd>
          <dt>
            <span id="sgst">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryBill.sgst">Sgst</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryBillEntity.sgst}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryBill.active">Active</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryBillEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryBill.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryBillEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryBill.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryBillEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryBill.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryBillEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.diagLabInventoryBill.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{diagLabInventoryBillEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diagLabInventoryBill.diagLab">Diag Lab</Translate>
          </dt>
          <dd>{diagLabInventoryBillEntity.diagLab ? diagLabInventoryBillEntity.diagLab.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diagLabInventoryBill.supplier">Supplier</Translate>
          </dt>
          <dd>{diagLabInventoryBillEntity.supplier ? diagLabInventoryBillEntity.supplier.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/diag-lab-inventory-bill" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/diag-lab-inventory-bill/${diagLabInventoryBillEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DiagLabInventoryBillDetail;
